/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowUpDown16: {
  name: 'arrow-up-down-16';
  data: string;
} = {
  name: 'arrow-up-down-16',
  data: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18"><path d="M6.75 7v6.125a.875.875 0 0 1-.875.875h-1.75a.875.875 0 0 1-.875-.875V7H1.498A.875.875 0 0 1 .77 5.64L4.271.39a.875.875 0 0 1 1.456 0l3.502 5.25A.875.875 0 0 1 8.501 7H6.75zm10 4H18.5a.875.875 0 0 1 .728 1.361l-3.502 5.25a.875.875 0 0 1-1.456 0l-3.5-5.25a.875.875 0 0 1 .727-1.36h1.752V4.874c0-.483.391-.875.875-.875h1.75c.483 0 .875.392.875.875V11z"/></svg>`
};
